import { useTranslation } from "react-i18next";

import articleDeliveryStatuses from "astrid-firestore/src/api/articles/constants/articleDeliveryStatuses";

export default function useArticleDeliveryStatuses(deliveryData) {
	const { t } = useTranslation();

	return {
		[articleDeliveryStatuses.DELIVERY_UNSUPPORTED]: {
			text: t("unsupported", "Unsupported"),
			color: "grey",
			disabled: true,
		},
		[articleDeliveryStatuses.DELIVERY_NOT_STARTED]: {
			text: t("notDelivered", "Not delivered"),
			color: "grey",
		},
		[articleDeliveryStatuses.DELIVERY_PENDING]: {
			text: t("scheduled", "Scheduled"),
			color: "blue",
		},
		[articleDeliveryStatuses.DELIVERY_IN_PROGRESS]: {
			text: t("inProgress", "In progress"),
			color: "blue",
			active: true,
		},
		[articleDeliveryStatuses.DELIVERY_COMPLETED]: {
			text: t("delivered", "Delivered"),
			color: "green",
		},
		[articleDeliveryStatuses.DELIVERY_FAILED]: {
			text: `${t("failed", "Failed")}${deliveryData?.error ? `: ${deliveryData.error}` : ""}`,
			color: "red",
		},
		[articleDeliveryStatuses.DELIVERY_NEEDED]: {
			text: t("deliveryNeeded", "Delivery needed"),
			color: "orange",
		},
	};
}
